import type { Middleware } from "@reduxjs/toolkit";
import { t } from "i18next";

import {
  setEditMode,
  setUIMode,
  toggleEditMode,
} from "@/features/app/appSlice";
import {
  changeBuilding,
  setCurrentBuildingID,
} from "@/features/cartography/cartographySlice";

import { promptUserWithUnsavedEditorChanges } from "@/features/editor/actions";

/**
 * Ask the user before changing building and/or UI mode of the app
 * if any unsaved changes have been detected in the editor
 */
const unsavedEditorChangesMiddleware: Middleware =
  (_store) => (next) => (action) => {
    if (
      setUIMode.match(action) ||
      setEditMode.match(action) ||
      toggleEditMode.match(action) ||
      setCurrentBuildingID.match(action) ||
      changeBuilding.match(action)
    ) {
      if (
        !promptUserWithUnsavedEditorChanges(
          t("dialogs.unsaved_changes.message", {
            ns: "editor",
          }),
        )
      ) {
        return;
      }
    }

    return next(action);
  };

export default unsavedEditorChangesMiddleware;
